module.exports = __webpack_public_path__ + "img/avatar6.f41218f9.png";